import { render, staticRenderFns } from "./ApiLogs.vue?vue&type=template&id=236934aa&scoped=true"
import script from "./ApiLogs.vue?vue&type=script&lang=js"
export * from "./ApiLogs.vue?vue&type=script&lang=js"
import style0 from "./ApiLogs.vue?vue&type=style&index=0&id=236934aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236934aa",
  null
  
)

export default component.exports